import { Grid2, Typography } from '@mui/material'
import React from 'react'
import mission from "../../../assets/Home/misssion.png"
import vision from "../../../assets/Home/vision.jpg"

export function AboutVision() {
  return (
    <Grid2 justifyContent="space-around" flexDirection="column"  width="100%" gap="30px" className="vm-container info" margin="20px 0px">
        <Grid2 container className="missioncontainer" flexDirection="column" justifyContent="center" alignItems="center">
        <Typography className="missionheading" sx={{fontWeight:"600",fontSize:"20px"}}> OUR MISSION</Typography>
           <Grid2 className="missiondata" sx={{display:"flex",flexDirection:"column",width:"100% !important", alignItems:"center", gap:"20px"}}>
            <img width="90%" style={{borderRadius:"20px"}} src={mission} alt="" />
            <Typography className="missiontext" width="90%">Lorem ipsum dolor sit, amet consectetur adipisicing elit. A eaque pariatur labore esse libero omnis quod quisquam soluta sequi, nemo impedit facere totam aut tempora eius amet incidunt dolore nisi?</Typography>
           </Grid2> 
        </Grid2>

        <Grid2 container className="missioncontainer" flexDirection="column" justifyContent="center" alignItems="center">
        <Typography className="missionheading" sx={{fontWeight:"600",fontSize:"20px"}}>OUR VISION</Typography>
           <Grid2 className="missiondata" sx={{display:"flex",flexDirection:"column",width:"100% !important", alignItems:"center", gap:"20px"}}>
            <img width="90%" style={{borderRadius:"20px"}} sx={{opacity:"0.5 !important"}} src={vision} alt="" />
            <Typography className="missiontext" width="90%">Lorem ipsum dolor sit, amet consectetur adipisicing elit. A eaque pariatur labore esse libero omnis quod quisquam soluta sequi, nemo impedit facere totam aut tempora eius amet incidunt dolore nisi?</Typography>
           </Grid2> 
        </Grid2>

        {/* <Grid2 container className="visioncontainer">
        <Typography className="visionheading" sx={{fontWeight:"600"}}></Typography>

           <Grid2 className="visiondata">
           <img width="200px" sx={{ backgroundBlendMode:"multiply"}} src={vision} alt="" />
            <Typography className="visiontext">Lorem ipsum dolor sit, amet consectetur adipisicing elit. A eaque pariatur labore esse libero omnis quod quisquam soluta sequi, nemo impedit facere totam aut tempora eius amet incidunt dolore nisi?</Typography>
           </Grid2> 
        </Grid2> */}
    </Grid2>
  )
}

 